import Footer from '@components/shared/Footer/Footer';
import VehicleInfoConfirmForm from '@components/VehicleInfoConfirmForm/VehicleInfoConfirmForm';
import { useTexts } from 'utils/useTexts';

const VehicleInfoConfirm = () => {
  const { t } = useTexts();
  return (
    <>
      <VehicleInfoConfirmForm />
      <Footer text={t('verifyVehicleInfo.footer.footerText')} />
    </>
  );
};

export default VehicleInfoConfirm;
